/* eslint-disable no-empty-pattern */
import kitsu from '@plugins/kitsu';
import http from '@plugins/axios';
import { queryString } from '@utils/format';
let $ajax;

export const actions = {
  async fetch({ rootState }, payloads) {
    const id = rootState.auth.instansi_id;

    return await http
      .get(`/psp/i/${id}/pendampingan-lokakarya-dinas?${queryString(payloads.params)}`)
      .then(({ data }) => data);
  },

  async getOpsi({ rootState }) {
    const id = rootState.auth.instansi_id;

    return await http.get(`/psp/i/${id}/pendampingan-lokakarya-dinas/opsi`).then(({ data }) => data);
  },

  async getDetail({ rootState }, payloads) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/pendampingan-lokakarya-dinas`,
    });
    return await $ajax.get(`/${payloads.id}`);
  },

  save({ rootState }, payloads) {
    const id = rootState.auth.instansi_id;
    const lokakaryaDinasId = payloads.id ? `${payloads.id}/` : '';
    return http
      .post(`/psp/i/${id}/pendampingan-lokakarya-dinas/${lokakaryaDinasId}${payloads.action}`, payloads.params)
      .then(({ data }) => data);
  },

  actions({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/pendampingan-lokakarya-dinas/${payload.id ? payload.id + '/' : ''}${payload.action}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  upload({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/pendampingan-lokakarya-dinas/berkas/${payload.id}/insert`, payload.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  delete({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/pendampingan-lokakarya-dinas/berkas/${payload.id}/delete`);
  },

  downloadList({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/pendampingan-lokakarya-dinas/${payload.url}?${queryString(
      payload.params
    )}`;

    return Promise.resolve(url);
  },
};
